import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import PageLoading from "../../helpers/PageLoading";
import React, { useContext, useEffect } from "react";
import { useParams } from "react-router";
import { getDuration, getError, getSuccessMessage } from "../../store/helpers/common_functions";
import {
    Avatar,
    AvatarGroup,
    Box,
    Button, CardActionArea, Checkbox,
    CircularProgress,
    Dialog, DialogContent,
    DialogTitle,
    LinearProgress,
    Tooltip,
    Typography,
    IconButton,
    TextField,
    Tabs,
    Tab,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    MenuItem,

} from "@mui/material";
import CommentManager from "../../views/admin/CommentManager";

import moment from "moment/moment";
import TaskDndProvider from "../../components/Project/TaskDndProvider";
import { downloadUrl } from "../../Shared/commonFunction";
import { errorToast, successToast } from "../../helpers/Notification";
import StyledBadge from "../../helpers/StyledBadge";
import { grey } from "@mui/material/colors";
import WorklogManager from "./WorklogManager";
import QtMaterialButton from "../../components/QtMaterialButton";
import SearchIcon from '@mui/icons-material/Search';
import { Edit } from "@mui/icons-material";

import SocketContext from "helpers/SocketContext";
import StatusLayout from "components/Status";
import AttachmentManager from "./AttachmentManager";
import axios from "axios";
import JoditEditorExample from "../../helpers/JoditEditorExample";
import { EditNotifications } from "@mui/icons-material";
import { BsPencil } from "react-icons/bs";
import DeleteDialog from "helpers/DeleteDialog";


function TaskPage({ FetchDetails, PutAction, loggedUser, systemSettings }) {
    const mainBackground = systemSettings?.mainBackground;

    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState();
    const [info, setInfo] = React.useState();
    const [assignOpen, setAssignOpen] = React.useState(false);
    const [selectedDev, setSelectedDev] = React.useState([]);
    const [assigning, setAssigning] = React.useState(false);
    const [accountableOpen, setAccountableOpen] = React.useState(false);
    const [selectedAccountable, setSelectedAccountable] = React.useState(null);
    const [assigningAccountable, setAssigningAccountable] = React.useState(false);
    const [logOpen, setLogOpen] = React.useState(false);
    const [canEditProject, setCanEditProject] = React.useState(false);
    const [searchOpen, setSearchOpen] = React.useState(false);
    const [searchText, setSearchText] = React.useState('');
    const [commentOpen, setCommentOpen] = React.useState(false);
    const [attachmentOpen, setAttachmentOpen] = React.useState(false);


    const socket = useContext(SocketContext);
    const { id } = useParams();
    const initiator = info?.task?.initiator === loggedUser?.Resource?.id
    const isAssignee = info?.assignees.find(v => v?.resourceId === loggedUser?.Resource?.id);
    const supervisor = info?.assignees.find(v => v.role === 'supervisor');
    const isSupervisor = supervisor?.Resource?.id === loggedUser?.Resource?.id
    const canEdit = canEditProject || isSupervisor || initiator || isAssignee
    const canEditAll = canEditProject || isSupervisor || initiator
    const [count, setCount] = React.useState(0);
    const [dataToEdit, setDataToEdit] = React.useState({});
    const [addNew, setAddNew] = React.useState(false);
    const formRef = React.useRef(null);
    const [validationErrors, setValidationErrors] = React.useState({});
    const [activeTab, setActiveTab] = React.useState(0);
    const [descriptionDialogOpen, setDescriptionDialogOpen] = React.useState(false);
    const [progress, setProgress] = React.useState(false);
    const [status, setStatus] = React.useState(info?.project?.status);

    const renderChallengeModal = () => (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <JoditEditorExample
                    htmlContent={dataToEdit?.overallStatus ?? ''}
                    onBlur={(str) => setDataToEdit((prev) => ({ ...prev, overallStatus: str.target.value }))}
                />
                {validationErrors.overallStatus && (
                    <div style={{ color: 'red', marginTop: '0.5rem' }}>
                        {validationErrors.overallStatus}
                    </div>
                )}
            </div>
        </div>
    );

    const taskId = info?.task.id;
    const updateTask = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`/api/task/update/overall-status/${taskId}`, {
                overallStatus: dataToEdit.overallStatus,
            });
            setLoading(false);
            return response;
        } catch (error) {
            setLoading(false);
            throw error;
        }
    };

    const form = (
        <form ref={formRef} onSubmit={(e) => {
            e.preventDefault();
            updateTask().then((response) => {
                if (response.status === 200) {
                    successToast('Task updated successfully');
                    setAddNew(false);
                    setDataToEdit({});
                    setValidationErrors({});
                } else {
                    setValidationErrors(response.data);
                }
            }).catch((error) => {
                setValidationErrors({ description: error.message });
            });
        }}>
            {renderChallengeModal()}
            <div className={'px-2'} style={{ display: 'flex', marginTop: '1rem' }}>
                {loading ? <CircularProgress /> :
                    <>
                        <Button
                            variant={'contained'}
                            color="error"
                            onClick={() => {
                                setAddNew(false);
                                setDataToEdit({});
                                setValidationErrors({});
                            }}
                        >
                            Cancel
                        </Button>
                        <Button style={{ marginLeft: '5px' }} variant={'contained'} type={'submit'} sx={{ backgroundColor: mainBackground }}>
                            Submit
                        </Button>
                    </>
                }
            </div>
        </form>
    );


    const loadData = async () => {
        setLoading(true);
        setError(null);
        const resp = await FetchDetails(`/api/task/details/${id}`);
        console.log(resp);
        setLoading(false);
        if (resp.status) {
            setInfo(resp.data);
            setSelectedDev(resp.data.assignees.map(v => v.resourceId));
        } else {
            setError(getError(resp));
        }
        return resp;
    };

    const success = () => setCount((v) => v + 1);


    useEffect(() => {
        loadData();
    }, [id, loggedUser]);

    function extractBodyContent(html) {
        if (!html) return '';
        const match = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
        if (match) return match[1];
        return html;
    }


    const assignTeam = async () => {
        if (!selectedDev.length) {
            errorToast("Select at least one project member !");
            return;
        }

        setAssigning(true);
        const resp = await PutAction(`/api/task/assign/team/${id}`, { team: selectedDev });

        if (resp.status) {
            selectedDev.forEach(v => {
                socket.emit('sendNotification', {
                    resourceId: loggedUser.Resource.id,
                    receiverId: v,
                    type: 'task_assigned',
                });
            });
            await loadData();
            successToast(getSuccessMessage(resp));
            setAssignOpen(false);
            window.location.reload();
        } else {
            errorToast(getError(resp));
        }
        setAssigning(false);
    };

    const assignAccountable = async () => {
        if (!selectedAccountable) {
            errorToast("Please select an accountable person!");
            return;
        }

        setAssigningAccountable(true);
        const resp = await PutAction(`/api/task/assign/lead/${id}`, { accountableId: selectedAccountable });

        if (resp.status) {
            socket.emit('sendNotification', {
                resourceId: loggedUser.Resource.id,
                receiverId: selectedAccountable,
                type: 'task_accountable_assigned',
            });
            await loadData();
            successToast(getSuccessMessage(resp));
            setAccountableOpen(false);
            // window.location.reload();
        } else {
            errorToast(getError(resp));
        }
        setAssigningAccountable(false);
    };



    const teamItem = (resource) => {
        const onClick = () => {
            setSelectedDev((prev) =>
                prev.includes(resource.id)
                    ? prev.filter(id => id !== resource.id)
                    : [...prev, resource.id]
            );
        };

        const checked = selectedDev.includes(resource.id);

        return (
            <div className={`mr-2 relative mb-2`}>
                <div className={'absolute right-0'} style={{ zIndex: "10", top: "-10px" }}>
                    <Checkbox onChange={onClick} checked={checked} />
                </div>
                <CardActionArea onClick={onClick}>
                    <StyledBadge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    >
                        <Avatar
                            sx={{ bgcolor: grey[300], width: 60, height: 60 }}
                            alt={resource.names}
                            src={resource.profile ? `${downloadUrl}/${resource.profile}` : undefined}
                        />
                    </StyledBadge>
                    <div style={{ width: "130px" }}>
                        <Typography
                            sx={{
                                display: '-webkit-box',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 1,
                            }}
                            variant={'body2'}
                        >
                            {resource.names}
                        </Typography>
                        <Typography
                            sx={{
                                display: '-webkit-box',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 1,
                            }}
                            variant={'subtitle2'}
                            style={{ fontWeight: "bold" }}
                        >
                            {resource.category}
                        </Typography>
                    </div>
                </CardActionArea>
            </div>
        );
    };

    const filteredMembers = info?.allMembers?.filter((member) => {
        const nameMatches = member.Resource?.names.toLowerCase().includes(searchText.toLowerCase());
        const categoryMatches = member.Resource?.category?.toLowerCase().includes(searchText.toLowerCase());
        return nameMatches || categoryMatches;
    });

    return (loading && !info) || error || !info ? (
        <>

            <PageLoading error={loading ? null : error} onRefresh={loadData} />
        </>
    ) :


        <div className={'flex flex-wrap'}>
            <WorklogManager taskId={id} open={logOpen} setOpen={() => setLogOpen(false)} canViewAll={canEditAll} />

            <Dialog open={assignOpen} onClose={() => setAssignOpen(false)}>
                <DialogTitle style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ flexGrow: 1 }}>
                        {info?.allMembers?.length === 0
                            ? 'There are currently no assignees for this project.'
                            : 'Assign Team to this task'}
                    </div>
                    {searchOpen ? (
                        <TextField
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Search..."
                            size="small"
                            style={{
                                marginLeft: '8px',
                                flexGrow: 1,
                                padding: '4px',
                                fontSize: '0.875rem',
                            }}
                            InputProps={{
                                style: {
                                    borderWidth: '1px',
                                    borderColor: '#ccc',
                                },
                            }}
                            onBlur={() => setSearchOpen(false)}
                            autoFocus
                        />
                    ) : (
                        <IconButton
                            onClick={() => setSearchOpen(true)}
                            aria-label="search"
                        >
                            <SearchIcon />
                        </IconButton>
                    )}
                </DialogTitle>

                <DialogContent>
                    <div className={'flex flex-wrap text-center justify-center'}>
                        {filteredMembers?.map(v => teamItem(v.Resource))}
                    </div>
                    <div className={'text-center mt-3'}>
                        {assigning ? <CircularProgress /> : filteredMembers?.length ? (
                            <>
                                <div>
                                    <QtMaterialButton variant={'contained'} onClick={assignTeam}>Assign Team</QtMaterialButton>
                                </div>
                                <div>
                                    <Button onClick={() => setAssignOpen(false)}>Cancel</Button>
                                </div>
                            </>
                        ) : null}
                    </div>
                </DialogContent>
            </Dialog>


            <Dialog open={accountableOpen} onClose={() => setAccountableOpen(false)}>
                <DialogTitle>
                    Assign Accountable Person
                </DialogTitle>
                <DialogContent>
                    <RadioGroup
                        value={selectedAccountable || (() => {
                            // Pre-select supervisor if exists
                            const supervisor = info?.assignees?.find(assignee => assignee.role === 'supervisor');
                            return supervisor ? supervisor.resourceId : '';
                        })()}
                        onChange={(e) => setSelectedAccountable(e.target.value)}
                        name="accountable"
                        style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}

                    >
                        <div className={'flex flex-wrap justify-center'}>
                            {info?.assignees?.map(member => {
                                const resource = member.Resource;
                                return (
                                    <div key={resource.id} className="flex flex-col items-center p-2 m-1">
                                        <Avatar
                                            alt={resource.names}
                                            src={resource.profile ? `${downloadUrl}/${resource.profile}` : undefined}
                                            sx={{ width: 40, height: 40, margin: '0 auto' }}
                                        />
                                        <FormControlLabel
                                            value={resource.id.toString()}
                                            control={<Radio
                                                sx={{
                                                    '&.Mui-checked': {
                                                        color: mainBackground,
                                                    },
                                                }}
                                            />}
                                            label={resource.names}
                                            labelPlacement="bottom"
                                            sx={{ margin: 0 }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </RadioGroup>
                    <div className={'text-center mt-3'}>
                        {assigningAccountable ? <CircularProgress /> : (
                            <>
                                <div>
                                    <QtMaterialButton
                                        variant={'contained'}
                                        onClick={assignAccountable}
                                        disabled={!selectedAccountable}
                                    >
                                        Assign Accountable
                                    </QtMaterialButton>
                                </div>
                                <div>
                                    <Button onClick={() => setAccountableOpen(false)}>Cancel</Button>
                                </div>
                            </>
                        )}
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog
                open={descriptionDialogOpen}
                onClose={() => setDescriptionDialogOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogContent>
                    <div className={"flex items-center"}>
                        <div className={"flex-grow font-bold text-lg"}>
                            <Typography variant="h6" className="mb-3">Task Description</Typography>
                        </div>
                        <IconButton onClick={() => setDescriptionDialogOpen(false)}>
                            <img
                                src={require("assets/icons/close.svg").default}
                                alt={"close"}
                            />
                        </IconButton>
                    </div>
                    <Typography
                        variant="body1"
                        component="div"
                        sx={{ wordBreak: 'break-word' }}
                        dangerouslySetInnerHTML={{
                            __html: extractBodyContent(info?.task?.description)
                        }}
                    />
                </DialogContent>
            </Dialog>

            <DeleteDialog
                open={progress}
                setOpen={() => {
                    setProgress(false);
                }}
                onSuccess={async () => {
                    await loadData();
                }}
                info={true}
                title={"Progress Status"}
                bodyText={
                    <div className={"py-3 text-left"}>
                        <FormControl fullWidth={true} size={"small"}>
                            <InputLabel id="demo-simple-select-label">Status</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={status}
                                label="Status"
                                onChange={(e) => setStatus(e.target.value)}
                            >
                                <MenuItem value={"in-progress"}>In Progress</MenuItem>
                                <MenuItem value={"to-verify"}>Under Review</MenuItem>
                                <MenuItem value={"on-hold"}>On Hold</MenuItem>
                                { canEdit ? (
                                    <MenuItem value={"completed"}>Completed</MenuItem>
                                ) : null}

                            </Select>

                        </FormControl>
                    </div>
                }
                url={`/api/task/change-status/${id}?status=${status}`}
            />

            <div className="w-full xl:w-12/12 px-4">
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg border-0">
                    <div className="rounded bg-white mb-0 px-0 py-0 overflow-hidden">
                        {loading ? <LinearProgress /> : null}
                        <div className="px-6 py-6">
                            <div className="mt-0 mb-2">
                                <div className="text-xl leading-normal mt-0 mb-3 text-blueGray-400 font-bold uppercase">
                                    {info.task.name}
                                </div>

                                <div className="border rounded-lg p-4 shadow-sm bg-white">
                                    <div className="grid grid-cols-3 gap-4">
                                        <div className="flex flex-col gap-4">
                                            <div>
                                                <h3 className="text-sm font-bold text-gray-700">Task Start-End Date</h3>
                                                {/* <p className="text-gray-600"> {moment(info.task.startDate).format("YYYY-MMM-DD") + ' '}
                                                    - {' ' + moment(info.task.endDate).format("YYYY-MMM-DD")}
                                                </p> */}

                                                <p className="text-gray-600">
                                                    {moment(info.task.startDate)
                                                        .utc()
                                                        .format("YYYY-MMM-DD HH:mm") + " "}
                                                    -{" "}
                                                    {" " +
                                                        moment(info.task.endDate)
                                                            .utc()
                                                            .format("YYYY-MMM-DD HH:mm")}
                                                </p>
                                            </div>
                                            <div>
                                                <h3 className="text-sm font-semibold text-gray-700">Assigned</h3>
                                                <p className="text-gray-600">
                                                    {info?.assignees?.length > 0 && <>
                                                        <div className="w-1/2">
                                                            <div className={'flex flex-start'}>
                                                                <AvatarGroup total={info.assignees.length}>
                                                                    {info.assignees.map(item =>
                                                                        <Tooltip arrow={true} title={item.Resource.names} key={item.Resource.names}>
                                                                            <Avatar
                                                                                alt={item.Resource.names}
                                                                                src={item.Resource.profile ? `${downloadUrl}/${item.Resource.profile}` : undefined} />
                                                                        </Tooltip>
                                                                    )}
                                                                </AvatarGroup>
                                                            </div>
                                                        </div>
                                                    </>}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-4">
                                            <div>
                                                <h3 className="text-sm font-semibold text-gray-700">Task Duration</h3>
                                                <p className="text-gray-600">{getDuration(info.task.endDate, info.task.startDate)}</p>
                                            </div>
                                            <div>
                                                <h3 className="text-sm font-semibold text-gray-700">Status</h3>
                                                <StatusLayout status={info.task.status} />
                                                <IconButton
                                                    onClick={() => {
                                                        setProgress(true);
                                                    }}
                                                    className="text-gray-500 hover:text-gray-700"
                                                >
                                                    <Edit />
                                                </IconButton>
                                            </div>
                                        </div>
                                        <div>
                                            <h3 className="text-sm font-semibold text-gray-700">Task Description</h3>
                                            <div className="text-gray-600 font-normal text-sm">
                                                {info.task.description?.length > 100 ? (
                                                    <>
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: extractBodyContent(info.task.description.substring(0, 100))
                                                            }}
                                                        />
                                                        ...
                                                        <Button
                                                            size="small"
                                                            onClick={() => setDescriptionDialogOpen(true)}
                                                            sx={{
                                                                textTransform: 'none',
                                                                color: mainBackground,
                                                                '&:hover': {
                                                                    backgroundColor: 'transparent',
                                                                    textDecoration: 'underline'
                                                                }
                                                            }}
                                                        >
                                                            View more
                                                        </Button>
                                                    </>
                                                ) : (
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: extractBodyContent(info.task.description)
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Tabs
                                value={activeTab}
                                onChange={(event, newValue) => setActiveTab(newValue)}

                                sx={{
                                    "& .MuiTabs-indicator": {
                                        backgroundColor: mainBackground,
                                        // display: "none",
                                    },
                                    "& .MuiTab-root": {
                                        fontSize: "13px",
                                        lineHeight: "15.73px",
                                        fontWeight: "400",
                                    },
                                    "& .Mui-selected": {
                                        backgroundColor: mainBackground,
                                        color: "#ffffff", // White text for selected tab
                                        fontWeight: "600",
                                        fontSize: "13px",
                                        borderRadius: "8px",
                                    },
                                    "& .MuiTab-root.Mui-selected": {
                                        color: "#ffffff",
                                    },
                                }}
                                aria-label="basic tabs example"
                            >
                                <Tab
                                    label="Assign Users"
                                    onClick={() => setAssignOpen(true)}
                                    sx={{
                                        backgroundColor: activeTab === 0 ? mainBackground : 'transparent',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                    }}
                                />
                                <Tab
                                    label="Comments"
                                    onClick={() => setCommentOpen(true)}
                                    sx={{
                                        backgroundColor: activeTab === 1 ? mainBackground : 'transparent',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                    }}
                                />
                                <Tab
                                    label="Attachments"
                                    onClick={() => setAttachmentOpen(true)}
                                    sx={{
                                        backgroundColor: activeTab === 2 ? mainBackground : 'transparent',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                    }}
                                />
                                <Tab
                                    label="Worklogs"
                                    onClick={() => setLogOpen(true)}
                                    sx={{
                                        backgroundColor: activeTab === 3 ? mainBackground : 'transparent',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                    }}
                                />
                                {/* <Tab
                                    label="Overall Status"
                                    
                                    onClick={async () => {
                                        try {
                                            const response = await axios.get(`/api/task/get/overall-status/${id}`);
                                            const { id: taskId, name, overallStatus } = response.data;
                                            setDataToEdit({ id: taskId, name, overallStatus });
                                            setAddNew(true);

                                        } catch (error) {
                                        } finally {
                                            setLoading(false);
                                        }
                                    }}
                                    sx={{
                                        backgroundColor: activeTab === 4 ? mainBackground : 'transparent',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                    }}
                                /> */}
                            </Tabs>
                            <div className="grid grid-cols-12 gap-4 mt-10">

                                <div className="col-span-4 flex flex-col items-start">
                                    <Typography variant={'h6'}>Created by</Typography>
                                    {info?.task?.initiator === loggedUser?.Resource?.id ? (
                                        <div className="flex items-center mt-1">
                                            <div style={{ marginRight: '8px' }}>
                                                <h3>Me</h3>
                                            </div>
                                            <Avatar
                                                alt="Me"
                                                src={loggedUser?.Resource?.profile ? `${downloadUrl}/${loggedUser.Resource.profile}` : undefined}
                                                sx={{ width: 20, height: 22 }}
                                            />
                                        </div>
                                    ) : (
                                        (() => {
                                            const creator = info.allMembers.find(member => member.Resource.id === info.task.initiator)?.Resource;
                                            return creator ? (
                                                <div className="flex items-center mt-1">
                                                    <div style={{ marginRight: '8px' }}>
                                                        <h3>{creator.names}</h3>
                                                    </div>
                                                    <Avatar
                                                        alt={creator.names}
                                                        src={creator.profile ? `${downloadUrl}/${creator.profile}` : undefined}
                                                        sx={{ width: 20, height: 20 }}
                                                    />
                                                </div>
                                            ) : (
                                                <h3 className="mt-1">Unknown</h3>
                                            );
                                        })()
                                    )}
                                </div>

                                <div className="col-span-4 flex flex-col items-start">
                                    <Typography variant={'h6'}>Accountable</Typography>
                                            {(() => {
                                                const supervisor = info.assignees.find(assignee => assignee.role === 'supervisor');

                                                if (supervisor) {
                                                    if (supervisor.resourceId === loggedUser?.Resource?.id) {
                                                        return (
                                                            <div className="flex items-center mb-2">
                                                                <div style={{ marginRight: '8px' }}>
                                                                    <h3>Me</h3>
                                                                </div>
                                                                <Avatar
                                                                    alt="Me"
                                                                    src={loggedUser?.Resource?.profile ? `${downloadUrl}/${loggedUser.Resource.profile}` : undefined}
                                                                    sx={{ width: 20, height: 22 }}
                                                                />

                                                                <IconButton size="small" onClick={() => {
                                                                    // Pre-select supervisor if exists
                                                                    const supervisor = info?.assignees?.find(assignee => assignee.role === 'supervisor');
                                                                    if (supervisor) {
                                                                        setSelectedAccountable(supervisor.resourceId);
                                                                    }
                                                                    setAccountableOpen(true);
                                                                }}>
                                                                    <BsPencil />
                                                                </IconButton>
                                                            </div>
                                                        );
                                                    } else {
                                                        return (
                                                            <div className="flex items-center mb-2">
                                                                <div style={{ marginRight: '8px' }}>
                                                                    <h3>{supervisor.Resource.names}
                                                                    </h3>
                                                                </div>
                                                                <Avatar
                                                                    alt={supervisor.Resource.names}
                                                                    src={supervisor.Resource.profile ? `${downloadUrl}/${supervisor.Resource.profile}` : undefined}
                                                                    sx={{ width: 20, height: 20 }}
                                                                />

                                                                {/* Edit */}
                                                                <IconButton size="small" onClick={() => {
                                                                    // Pre-select supervisor if exists
                                                                    const supervisor = info?.assignees?.find(assignee => assignee.role === 'supervisor');
                                                                    if (supervisor) {
                                                                        setSelectedAccountable(supervisor.resourceId);
                                                                    }
                                                                    setAccountableOpen(true);
                                                                }}>
                                                                    <BsPencil  />
                                                                </IconButton>
                                                            </div>
                                                        );
                                                    }
                                                } else {
                                                    // No supervisor found - show assign button if user can edit
                                        return canEdit ? (
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={() => {
                                                    // Pre-select supervisor if exists
                                                    const supervisor = info?.assignees?.find(assignee => assignee.role === 'supervisor');
                                                    if (supervisor) {
                                                        setSelectedAccountable(supervisor.resourceId);
                                                    }
                                                    setAccountableOpen(true);
                                                }}
                                                sx={{ color: mainBackground, "&:hover": { color: mainBackground } }}
                                            >
                                                Assign Accountable
                                            </Button>
                                        ) : (
                                            <h3 className="text-gray-500">Not assigned</h3>
                                        )
                                    }
                                })()}
                                </div>

                                {info?.task?.meeting && (
                                    <div className="col-span-4">
                                        <div className="flex flex-col items-start">
                                            <Typography variant={'h6'}>Originated From</Typography>
                                            <h3 className="">
                                                {info.task.meeting.name}
                                            </h3>
                                        </div>
                                    </div>
                                )}
                                <div className="col-span-4">
                                    <div className="flex flex-col items-end">
                                        <div className={'mt-2'}>

                                            <AttachmentManager
                                                taskId={id}
                                                task={info?.task}
                                                openAttachment={attachmentOpen}
                                                setOpen={() => setAttachmentOpen(false)}
                                                onClose={() => {
                                                    setAttachmentOpen(false);
                                                }}
                                                onSuccess={success}
                                                canViewAll={canEdit}
                                            />

                                            <CommentManager
                                                taskId={id}
                                                task={info?.task}
                                                open={commentOpen}
                                                setOpen={() => setCommentOpen(false)}
                                                onClose={() => {
                                                    setCommentOpen(false);
                                                }}
                                                onSuccess={loadData}
                                                canViewAll={canEdit}
                                            />

                                            <Dialog open={addNew} maxWidth={'lg'} fullWidth={true} onClose={() => setAddNew(false)}>
                                                <DialogTitle>Task Overall Status</DialogTitle>
                                                <DialogContent>{form}</DialogContent>
                                            </Dialog>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <Box sx={{ width: '100%' }}>
                            <TaskDndProvider PutAction={PutAction} onSuccess={loadData} task={info.task} members={info.assignees} subTasks={info.subTasks} canEdit={canEdit} />
                        </Box>
                    </div>
                </div>
            </div>

        </div>;
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskPage);